import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import Header from '../components/Dashboard/Header'
import Buy from '../components/Dashboard/Buy'
import Sell from '../components/Dashboard/Sell'
import styled from 'styled-components'
import Login from '../components/shared/Login'
import Signup from '../components/shared/Signup'
import Sidebar from '../components/shared/Sidebar'
import { fetchUserInfo } from '../utils/services/fetchUser'
import { fetchDatabase } from '../utils/services/fetchDatabase'

// Styled
const StyledDashboard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const StyledBuySell = styled.div`
    display: flex;
    width: 100vw;
    height: 100%;
    max-width: 1000px;
    box-shadow: 0 0 100px #00000055;
    border-radius: 15px;
`

const Dashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    const [isLoginVisible, setIsLoginVisible] = useState(false)
    const [isSignupVisible, setIsSignupVisible] = useState(false)

    // Get user info
    const {
        data: userInfo,
        isLoading: isLoadingUserInfo,
        isError: isErrorUserInfo,
    } = useQuery({
        queryKey: ['userInfo'],
        queryFn: fetchUserInfo,
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching user info:', err)
        },
    })

    // get the database of the stuff categories
    const { data: stuffCategories, isLoading: isLoadingStuffCategories } =
        useQuery({
            queryKey: ['categoryDatabase'],
            queryFn: fetchDatabase,
            staleTime: 60 * 60 * 1000,
            retry: 0,
            onError: (err) => {
                console.error('Error fetching stuff categories:', err)
            },
        })

    if (isLoadingUserInfo || isLoadingStuffCategories) {
        return <div>Chargement en cours...</div>
    }

    return (
        <StyledDashboard>
            {userInfo && (
                <Sidebar
                    setIsSidebarOpen={setIsSidebarOpen}
                    isSidebarOpen={isSidebarOpen}
                    userInfo={userInfo}
                />
            )}
            <Header
                setIsSidebarOpen={setIsSidebarOpen}
                setIsSignupVisible={setIsSignupVisible}
                setIsLoginVisible={setIsLoginVisible}
                isLoadingUserInfo={isLoadingUserInfo}
                isErrorUserInfo={isErrorUserInfo}
                userInfo={userInfo}
            />
            <StyledBuySell>
                <Buy userInfo={userInfo} stuffCategories={stuffCategories} />
                <Sell userInfo={userInfo} stuffCategories={stuffCategories} />
            </StyledBuySell>
            {isLoginVisible && <Login setIsLoginVisible={setIsLoginVisible} />}
            {isSignupVisible && (
                <Signup setIsSignupVisible={setIsSignupVisible} />
            )}
        </StyledDashboard>
    )
}

export default Dashboard
